import React, { useState , useEffect } from "react";
import { useDispatch , useSelector } from "react-redux";


import { useUser, useEquipes , useUsers,useEquipesManagers} from "../../state/reactquery";
import { defineleads,definefxnumeros,defineaffLeads,definechoiceliste,defineFilters,
         defineaffFxNum , definedate1, definedate2} from "../../state/redux";
import { queryClient } from '../../state/queryClient';
import { useCommerciaux ,useLeadsAndFxNumeros} from "../../state/reactquery";



import { filtersleads , definejsonequipes, jsonlistedates} from "../../utils/gestion";
import CalendarTwoPickers from "../../Components/Calendar/CalendarTwoPickers";

import './EcranGestionFiltersSearch.scss';






const classNames = require('classnames');
function EcranGestionFiltersSearch(){
    const dispatch = useDispatch() ;

    const {date1,date2,leads ,fxnumeros, filters, typetablo} = useSelector(state=>state.gestion);

    const [choicedate, setchoicedate] =  useState('today') ;
    const [choiceorigine, setchoiceorigine] =  useState('allorigines') ;
    const [choicecomp, setchoicecomp] =  useState('allcamps') ;
    const [choicegroupe, setchoicegroupe] =  useState('allcommerciaux') ;
    const [displaytwocalendars, setDisplaytwocalendars] =  useState(false) ;
    const [dates,setDates] =  useState({date1: null , date2:null}) ;
    const [gosearch,setGosearch] =  useState(false) ;
    const [origines, setOrigines] =  useState([]) ;
    const [showorigines, setShoworigines] =  useState(false) ;
    const [campagnes, setCampagnes] =  useState([]) ;
    const [showcampagnes, setShowcampagnes] =  useState(false) ;
    const [showcommerciaux, setShowcommerciaux] =  useState(false) ;
    const [showequipes, setShowequipes] =  useState(false) ;

   const {data:user} = useUser(localStorage.getItem('token'))  ;
   const {data:equipes} = useEquipes(user?.courtier)  ;
   const {data:users} = useUsers(user?.courtier) ;
   const {data:commerciaux} = useCommerciaux() ;
   const listeidadminsmanagers = users?.filter(u=>u.role==='ADMIN' || u.role==='MANAGER')?.map(x=>x.id)||[] ;
   const {data:equipes_managers} = useEquipesManagers(listeidadminsmanagers)  ;


   const typedate = typetablo==='gestion'?'date_origine' : 'date_lastmodif' ; 
   const {data:toto, status} =  useLeadsAndFxNumeros(date1,date2,typedate) ;




   const definedatesandseach= (date1,date2)=>{
    dispatch(definedate1(date1));
    dispatch(definedate2(date2));
    queryClient.invalidateQueries({ queryKey: ['leadsandfauxnumeros',date1,date2,typedate]}) ;
   }

    useEffect(()=>{  gosearch && definedatesandseach(dates.date1,dates.date2) ;},[gosearch]);

    let jsonequipes =definejsonequipes(equipes,users,equipes_managers);


    useEffect(()=>{dispatch(defineFilters({...filters, 'commerciaux': commerciaux||[]})) ;},[commerciaux])
    useEffect(()=>{handleresultquerry(toto) },[toto])


    function handleresultquerry(result){
        if(!result) {return }
        dispatch(defineleads(result?.['leads']));
        dispatch(definefxnumeros(result?.['fauxnumeros']));
        setOrigines([...new Set(result?.['leads']?.map(x=>x.origine))]) ;
        setCampagnes([...new Set(result?.['leads']?.map(x=>x.campagne?.split('/')?.[0]?.trim()))]) ; 
        const aff= filtersleads(result?.['leads'],filters) ;
        const affFx= filtersleads(result?.['fauxnumeros'],filters) ;
        dispatch(defineaffFxNum(affFx)); 
        dispatch(defineaffLeads(aff)); 
        // dispatch(definechoiceliste("choiceleadsrecus")) ;
        setDisplaytwocalendars(false) ; 
    }

    const clickchoicedate = (e)=>{ 

        setchoicedate(e.target.id) ;
        if(e.target.id!=='choicefromcal'){
            definedatesandseach(jsonlistedates[e.target.id]?.[0],jsonlistedates[e.target.id]?.[1]) ;
            setDisplaytwocalendars(false) ; 
        }else{setDisplaytwocalendars(!displaytwocalendars) }

    }  

    function changeaffleadsbyfilters(newfilters){
        const aff= filtersleads(leads,newfilters) ;
        dispatch(defineaffLeads(aff)); 
        const afffx= filtersleads(fxnumeros,newfilters) ;
        dispatch(defineaffFxNum(afffx)); 
        dispatch(defineFilters(newfilters)); 
    }

    const clickchoiceorigine = (e)=>{
        if(e.target.id==='allorigines'){changeaffleadsbyfilters({...filters,'origines':'allorigines'}) }
        setchoiceorigine(e.target.id) ; 
        e.target.id==='selectorigine' ? setShoworigines(!showorigines): setShoworigines(false)  ;
     } 

    const clickchoicecomp = (e)=>{ 
        if(e.target.id==='allcamps'){changeaffleadsbyfilters({...filters, 'campagnes':'allcamps'})   }
        setchoicecomp(e.target.id);  
        e.target.id==='selectcamp' ? setShowcampagnes(!showcampagnes)  : setShowcampagnes(false)  ;
    }  

    const clickchoicegroupe = (e)=>{
        setchoicegroupe(e.target.id);
        e.target.id==='allcommerciaux' && changeaffleadsbyfilters({...filters,'commerciaux':users.map(x=>x.nom)}) ;
        e.target.id==='selectcommercial' ? setShowcommerciaux(!showcommerciaux)  : setShowcommerciaux(false)  ;
        e.target.id==='selectequipe' ? setShowequipes(!showequipes)  : setShowequipes(false)  ;
    }  

    const filterbyorigine = (e)=>{ changeaffleadsbyfilters({...filters, 'origines':e.target.id}) ;setShoworigines(false) }  ;

    const filterbycampagne = (e)=>{changeaffleadsbyfilters({...filters,'campagnes':e.target.id}); setShowcampagnes(false) }  ;

    const filterbycommercial = (e)=>{changeaffleadsbyfilters({...filters,'commerciaux':[e.target.id]}); setShowcommerciaux(false) }  ;

    const filterbyequipe = (eq) =>{changeaffleadsbyfilters({...filters,'commerciaux':jsonequipes[eq.id]}); setShowequipes(false)}

    return(<div className="ecrangestionfilterssearch">    
                <div className="grpbtnstimes">
                    <button id="today"  onClick={clickchoicedate} className={classNames("btnchoice",{'first':true},{'last':false},{'selected':choicedate==="today"})} >Ajourd.</button>
                    <button id="lastweek" onClick={clickchoicedate} className={classNames("btnchoice",{'first':false},{'last':false},{'selected':choicedate==="lastweek"})} >Semaine Prec.</button>
                    <button id="thismonth" onClick={clickchoicedate} className={classNames("btnchoice",{'first':false},{'last':false},{'selected':choicedate==="thismonth"})} >Ce mois-ci</button>
                    <button id="lastmonth" onClick={clickchoicedate} className={classNames("btnchoice",{'first':false},{'last':false},{'selected':choicedate==="lastmonth"})} >Mois dern.</button>
                    <button id="choicefromcal" onClick={clickchoicedate} className={classNames("btnchoice",{'first':false},{'last':true},{'selected':choicedate==="choicefromcal"})} >Choisir dates</button>
                    {displaytwocalendars &&  <div className="containertwocalendars" >  <CalendarTwoPickers filtres={dates} setFiltres={setDates} setDisplaytwocalendars={setDisplaytwocalendars}   setGosearch={setGosearch} /> </div>   }
                </div>
        <div className="container_origines" >
           {showorigines && <div className="origines" >{origines.map(o=><div className="origine"   key={o} id={o} onClick={filterbyorigine}  >{o} </div> )}</div>}
            <button id="allorigines" onClick={clickchoiceorigine}  className={classNames("btnchoice",{'first':true},{'last':false},{'selected':choiceorigine==="allorigines"})} >Toutes orig.</button>
            <button id="selectorigine" onClick={clickchoiceorigine} className={classNames("btnchoice",{'first':false},{'last':true},{'selected':choiceorigine==="selectorigine"})} >{filters.origines==='allorigines' ?'Choisir orig.':filters.origines}</button>
        </div>
        <div className="container_campagnes" >
        {showcampagnes && <div className="origines" >{campagnes.map(o=><div className="origine"   key={o} id={o} onClick={filterbycampagne}  >{o} </div> )}</div>}
            <button id="allcamps" onClick={clickchoicecomp} className={classNames("btnchoice",{'first':true},{'last':false},{'selected':choicecomp==="allcamps"})} >Toutes camp.</button>
            <button id="selectcamp" onClick={clickchoicecomp}  className={classNames("btnchoice",{'first':false},{'last':true},{'selected':choicecomp==="selectcamp"})} > {filters.campagnes==='allcamps' ?'Choisir camp.':filters.campagnes}</button>                                                                                                                                
        </div>
        <div className="container_cabinet">
        {showcommerciaux && <div className="origines" >{[...commerciaux]?.sort().map(o=><div className="origine"   key={o} id={o} onClick={filterbycommercial}  >{o} </div> )}</div>}
        {showequipes && <div className="divequipes" >{equipes?.map(eq=><div className="origine"   key={eq.id} id={eq.id} onClick={()=>filterbyequipe(eq)}  >{eq.nom} </div> )}</div>}


{user?.role ==='MANAGER'?<>

    <button id="allcommerciaux"  onClick={clickchoicegroupe} className={classNames("btnchoice",{'first':true},{'last':false},{'selected':choicegroupe==="allcommerciaux"})} >Equipe</button>
            <button id="selectcommercial"   onClick={clickchoicegroupe}  className={classNames("btnchoice",{'first':false},{'last':true},{'selected':choicegroupe==="selectcommercial"})} >{filters.commerciaux?.length!==1?'Par conseiller':filters.commerciaux} </button>                                                               

</>:<><button id="allcommerciaux"  onClick={clickchoicegroupe} className={classNames("btnchoice",{'first':true},{'last':false},{'selected':choicegroupe==="allcommerciaux"})} >Tout le cabin.</button>
                    <button id="selectequipe"  onClick={clickchoicegroupe}  className={classNames("btnchoice",{'first':false},{'last':false},{'selected':choicegroupe==="selectequipe"})} >Par équipe</button>
                    <button id="selectcommercial"   onClick={clickchoicegroupe}  className={classNames("btnchoice",{'first':false},{'last':true},{'selected':choicegroupe==="selectcommercial"})} >{filters.commerciaux?.length!==1?'Par conseiller':filters.commerciaux} </button>                                                               </>}
                                                                                
        </div>
    </div>)
}

export default EcranGestionFiltersSearch ; 